/**
 * Created by Teo on 02/05/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchasesPerEmployeeSectorProduct', {
                parent: 'purchasesAggregated',
                url: '/perEmployeeSectorProduct',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP'],
                    pageTitle: 'Purchases Aggregated Per Employee Per Sector Per Product'
                },
                templateUrl: 'app/displays/adminIndex/purchasesAggregated/perEmployeeSectorProduct/purchasesPerEmployeeSectorProduct.html',
                controller: 'PurchasesAggregatedPerEmployeeSectorProductController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pharmacyVisitors: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/employees/by-authority/?authority=ROLE_PHARM_VISITOR&excludeSystem=true&activated=true').then(function (response) {
                            if (response && response.data){
                                angular.forEach(response.data, function (item) {
                                    item.fullName = item.account ? item.account.lastName + " " + item.account.firstName : ""
                                })
                            }
                            return response.data});
                    }],
                    accountingDeps: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/employees/by-authority/?authority=ROLE_ACCOUNTING_DEP&excludeSystem=true&activated=true').then(function (response) {
                            if (response && response.data){
                                angular.forEach(response.data, function (item) {
                                    item.fullName = item.account ? item.account.lastName + " " + item.account.firstName : ""
                                })
                            }
                            return response.data});
                    }],
                    purchaseProducts: ['$http','$stateParams', function ($http) {
                        return $http.get('/api/masterdata/min-products-for-purchases').then(function (response) {return response;});
                    }],
                    productCategories: ['ProductCategory', function (ProductCategory) {
                        return ProductCategory.query({page: 0, size: 200}).$promise;
                    }],
                    purchaseStatuses: ['$http','$stateParams', function ($http) {
                        var filters = {
                            data: {
                                "page": 1,
                                "pageSize": 30,
                                filter: {
                                    logic: "and",
                                    filters: [{
                                        field: "cancellable",
                                        operator: "eqbool",
                                        value: "false"
                                    }]
                                }
                            }
                        };
                        return $http.get('/api/masterdata/purchase-statuses', {params: filters.data}).then(function (response) {return response;});
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
